import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "dailyBudgetSuggestion", "dailyTargetCostSuggestion", "dailyRateMin", "dailyRateMax", "dailyStartDate", "dailyDueDate", "dailyRateCcy",
    "hourlyBudgetSuggestion", "hourlyTargetCostSuggestion", "hourlyRateMin", "hourlyRateMax", "hourlyStartDate", "hourlyDueDate", "hourlyLengthOfTime", "hourlyLengthOfTimeUnit", "hourlyUnsureLengthOfTime", "hourlyDefinedLengthOfTime", "hourlyRateCcy"
  ];

  connect() {
    this.dateFormat = window.I18n["js.date.formats.input"];
    this.addEventListeners();
    this.calculateBudget();
  }

  addEventListeners() {
    this.constructor.targets.forEach((target) => {
      const targetName = target + "Target";
      const hasTarget = this["has" + targetName.charAt(0).toUpperCase() + targetName.slice(1)];
      if (hasTarget) {
        const element = this[targetName];
        element.addEventListener("change", this.calculateBudget.bind(this));
        element.addEventListener("blur", this.calculateBudget.bind(this));
        if (target === "hourlyDefinedLengthOfTime" || target === "hourlyUnsureLengthOfTime") {
          element.addEventListener("change", this.toggleUnsureLengthOfTime.bind(this));
        }
      }
    });
  }

  calculateBudget() {
    const checkedInput = this.element.querySelector("input[name='job[job_type]']:checked");
    if (!checkedInput) return;

    const selectedJobType = checkedInput.value;
    switch (selectedJobType) {
      case "fixed":
        break;
      case "hourly":
        if (this.hourlyDefinedLengthOfTimeTarget.checked) {
          this.calculateHourlyBudget();
        }
        break;
      case "daily":
        this.calculateDailyBudget();
        break;
    }
  }

  calculateHourlyBudget() {
    const currency = this.hourlyRateCcyTarget.value;
    const startDate = moment(this.hourlyStartDateTarget.value, this.dateFormat);
    const dueDate = moment(this.hourlyDueDateTarget.value, this.dateFormat);
    const timeUnit = this.hourlyLengthOfTimeUnitTarget.value;
    const totalUnits = this.calculateTotalUnits(startDate, dueDate, timeUnit, this.hourlyLengthOfTimeTarget.value);
    const suggestedBudget = totalUnits * this.hourlyRateMaxTarget.value;
    const suggestedTargetCost = totalUnits * this.hourlyRateMinTarget.value;
    this.updateBudget(suggestedBudget, suggestedTargetCost, currency, this.hourlyBudgetSuggestionTarget, this.hashourlyTargetCostSuggestionTarget ? this.hourlyTargetCostSuggestionTarget : null);
  }

  calculateDailyBudget() {
    const currency = this.dailyRateCcyTarget.value;
    const startDate = moment(this.dailyStartDateTarget.value, this.dateFormat);
    const dueDate = moment(this.dailyDueDateTarget.value, this.dateFormat).add(1, "days");
    const workingDays = Math.max(momentBusiness.weekDays(startDate, dueDate), 0);
    const suggestedBudget = workingDays * this.dailyRateMaxTarget.value;
    const suggestedTargetCost = workingDays * this.dailyRateMinTarget.value;
    this.updateBudget(suggestedBudget, suggestedTargetCost, currency, this.dailyBudgetSuggestionTarget, this.hasDailyTargetCostSuggestionTarget ? this.dailyTargetCostSuggestionTarget : null);
  }

  calculateTotalUnits(startDate, dueDate, timeUnit, lengthOfTime) {
    const days = dueDate.diff(startDate, "days");
    const weeks = Math.ceil(days / 7);
    const months = Math.max(dueDate.diff(startDate, "months"), 1);
    switch (timeUnit) {
      case "total":
        return lengthOfTime;
      case "week":
        return weeks * lengthOfTime;
      case "month":
        return months * lengthOfTime;
      default:
        return lengthOfTime;
    }
  }

  updateBudget(budget, targetCost, currency, budgetTarget, targetCostTarget) {
    const formattedBudget = OSREC.CurrencyFormatter.format(budget, { currency });

    budgetTarget.textContent = "";

    if (budget > 0) {
      this.appendBudgetElement(budgetTarget, formattedBudget);
    }
    if (targetCostTarget) {
      const formattedTargetCost = OSREC.CurrencyFormatter.format(targetCost, { currency });
      targetCostTarget.textContent = "";
      if (targetCost > 0) {
        this.appendBudgetElement(targetCostTarget, formattedTargetCost);
      }
    }
  }

  appendBudgetElement(target, formattedValue) {
    const small = document.createElement("small");
    const icon = document.createElement("i");
    icon.className = "fa fa-level-up fa-rotate-90 sm-margin-left";
    small.appendChild(icon);
    const bold = document.createElement("b");
    bold.textContent = " Suggested: ";
    small.appendChild(bold);
    target.appendChild(small);

    const text = document.createTextNode(formattedValue);
    target.appendChild(text);
  }

  toggleUnsureLengthOfTime() {
    if (this.hourlyUnsureLengthOfTimeTarget.checked) {
      this.updateBudget(0, 0, '', this.hourlyBudgetSuggestionTarget, this.hourlyTargetCostSuggestionTarget);
    } else {
      this.calculateHourlyBudget();
    }
  }
}